'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objectUnfreeze = exports.objectToArray = exports.includesOne = exports.isIterable = undefined;

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ITERATOR_SYMBOL = (0, _isFunction2.default)(Symbol) && Symbol.iterator || '@@iterator';

var isIterable = exports.isIterable = function isIterable(arr) {
  return (0, _isObject2.default)(arr) && (0, _isFunction2.default)(arr[ITERATOR_SYMBOL]);
};

var includesOne = exports.includesOne = function includesOne(arr1, arr2) {
  return arr1.some(function (v) {
    return arr2.includes(v);
  });
};

var objectToArray = exports.objectToArray = function objectToArray(obj) {
  return (0, _isObject2.default)(obj) ? Object.keys((0, _pickBy2.default)(obj)) : [];
};

var objectUnfreeze = exports.objectUnfreeze = function objectUnfreeze(source) {
  var target = {};
  Object.keys(source).forEach(function (key) {
    target[key] = source[key];
  });
  Object.setPrototypeOf(target, Object.getPrototypeOf(source));
  return target;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/abyss-react/lib/utils.js
// module id = 132
// module chunks = 0